import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/auth/hooks/useAuth';
import { Loading } from '@/components/Shared/Loading';
import { routes } from '@/config/routes';

interface ProtectedRouteProps {
  requiredRoles?: string[];
}

export function ProtectedRoute({ requiredRoles = [] }: ProtectedRouteProps) {
  const { status, user, isProfileLoading } = useAuth();
  const location = useLocation();

  if (status === 'loading' || isProfileLoading) {
    return <Loading />;
  }

  if (status !== 'authenticated' || !user) {
    return (
      <Navigate
        to={routes.login}
        replace
        state={{ from: location.pathname + location.search }}
      />
    );
  }

  if (
    requiredRoles.length > 0 &&
    !requiredRoles.some((role) => user.roles.includes(role))
  ) {
    return (
      <Navigate
        to={routes.login}
        replace
        state={{
          from: location.pathname + location.search,
          reason: 'authUnauthorized',
        }}
      />
    );
  }

  return <Outlet />;
}
